export default __webpack_public_path__ + "static/media/pending.a2b50645.svg";